/* eslint-disable */
import React, { useState, useRef } from "react";
import "./styles.scss";
import Slider from "react-slick";
import projectData from "../../config/projectData";

const ProjectSlider = ({ selProject, setSelProject, isMobileLayout }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const slider123 = useRef();
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    beforeChange: (current, next) => {
      setActiveSlide(next);
    },
  };

  if (isMobileLayout) {
    return (
      <div className="project-slider-container">
        <div className="top-container">
          <h1>Products we are proud of</h1>
        </div>
        {projectData.map((project, j) => {
          return (
            <React.Fragment key={j}>
              <div className="mobile-project">
                <div
                  className="project-logo"
                  style={{
                    backgroundImage: `url(${project.url})`,
                  }}
                />
                <h2 className="mobile-project-title">
                  <b>{project.text}</b>
                </h2>
                <img
                  className="mobile-project-screenshot"
                  src={project.mobileImage}
                  alt={project.text}
                />
              </div>
              {j < projectData.length - 1 && <div className="divider project-divider" />}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  return (
    <div className="project-slider-container">
      <div className="text-info-container">
        <h1
          style={{ width: "90%", whiteSpace: "nowrap", paddingBottom: "0px", textTransform: "none" }}
        >
          Products we are proud of
        </h1>
        <div className="arrows-container">
          <div className="arrows">
            <div
              className={`left-arrow ${activeSlide === 0 && "inactive"}`}
              id="left"
              onClick={() => {
                slider123.current.slickPrev();
              }}
            />
            <div
              className={`right-arrow ${
                activeSlide + 3 === projectData.length && "inactive"
              }`}
              id="right"
              onClick={() => {
                slider123.current.slickNext();
              }}
            />
          </div>
        </div>
      </div>
      <Slider ref={slider123} style={{ marginLeft: "-4%" }} {...settings}>
        {projectData.map((project, j) => {
          return (
            <div
              className={`project ${
                project.text === selProject.text && project.selected
              }`}
              key={j}
              id={`project${j}`}
              onClick={() => {
                setSelProject(project);
              }}
            >
              <div
                className="project-image"
                style={{
                  backgroundImage: `url(${project.url})`,
                }}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default ProjectSlider;
